import axios from '../../../../api/axios'
import React,{useState,useEffect} from 'react'
import {useParams} from 'react-router-dom'
import Formulaire from '../../../ModelesPages/Modele1/Formulaire_enseignant'
import Sweetalert2 from 'react-sweetalert2'
import Swal from 'sweetalert2';
import {useNavigate} from 'react-router-dom'
import { useAuth } from '../../../../ContextApp/AuthContext'

function Update(){
    const {user}=useAuth();
    const [adresse,setAdresse]=useState("");
    const [lieu_naissance,setLieu_naissance]=useState("")
    const [date_naissance,setDate_naissance]=useState("")
    const [date_engagement,setDate_engagement]=useState("")
    const [nom,setNom]=useState("");
    const [postnom,setPostnom]=useState("");
    const [prenom,setPrenom]=useState("");
    const [email,setEmail]=useState("");
    const [telephone,setTelephone]=useState("");
    const [sexe,setSexe]=useState("");
    const [my_domaine,setMy_domaine]=useState("");
const [HandleSubmit_status, setHandleSubmit_status] = useState(false)
const [errors,setErrors]=useState({});
    const [niveau,setNiveau]=useState("");
    const [nom_complet,setNom_complet]=useState("")
    const [status_code,setStatus_code]=useState()
    const [status_message,setStatus_message]=useState("")
    const [swalProps,setSwalProp]=useState({})
    const navigate=useNavigate()
    function HandleAlert(){
        setSwalProp({
            show:true,
            title:'Mis à jour',
            icon:'success',
            
            timer:3000,
            
        })
    }
    const {id}=useParams()
    useEffect(()=>{
         HandleRequest()
    },[])
    
    const handleEmailChange = (e) => {
    setEmail(e.target.value.toLowerCase());
    
    // Nettoie dynamiquement l'erreur de l'email dès que l'utilisateur tape
    if (errors.email) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: null, // Supprime l'erreur spécifique à l'email
      }));
    }
  };
    const reinitialiser=async(nom,prenom)=>{
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Vous êtes sur le point de réinitialiser le mot de passe de l'enseignant " + nom + " " + prenom + ". Cette action est irréversible.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, réinitialiser!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`api/userinit/${id}`).then((res)=>{
                    Swal.fire(
                        'Réinitialisé!',
                        'Le mot de passe a été réinitialisé avec succès.',
                        'success'
                    )
                }).catch((err)=> {
                    
                })
            }   

        })
    }
    const HandleSubmit= async (e)=>{
        setHandleSubmit_status(true)
        await axios.put(`api/eleves/${id}`,{nom:nom.toLowerCase(),postnom:postnom.toLowerCase(),prenom:prenom.toLowerCase(),sexe:sexe,date_engagement:date_engagement,adresse:adresse.toLowerCase(),lieu_naissance:lieu_naissance.toLowerCase(),date_naissance:date_naissance,niveau:niveau,nom_complet:nom_complet.toLowerCase(),telephone:telephone,domaine:my_domaine,type_transact:"enseignant",idecole:user?.ecole?.id,idenseignant:id,email:email}).then((res)=>{
            setStatus_message(res.data.message)
            setStatus_code(res.data.status_code)
            setHandleSubmit_status(false)
                if(res.status===200){
                   HandleAlert();
                  navigate("/Enseignants", { replace: true });
               }
        }).catch((err)=>{
                    setHandleSubmit_status(false)
                    setErrors(err.response.data.errors)

        })
    }
   const HandleRequest=async ()=>{
        await axios.get(`api/eleves/${id}`).then((res)=>{

           if(res.data.status_code === 200) {
                setStatus_code(res.data.status_code)
                setNom(res.data.eleve.nom)
                setMy_domaine(res.data.eleve.domaine)
                setDate_engagement(res?.data?.date_engagement)
                setPostnom(res.data.eleve.postnom)
                setPrenom(res.data.eleve.prenom)
                setSexe(res.data.eleve.sexe)
                setAdresse(res.data.eleve.adresse)
                setLieu_naissance(res.data.eleve.lieu_naissance)
                setDate_naissance(res.data.eleve.date_naissance)
                setNom_complet(res.data.eleve.nom_complet)
                setNiveau(res.data.eleve.niveau)
                setTelephone(res.data.eleve.telephone)
                setEmail(res.data.user_email)
                
           }
           else{

           } 
          
        }).catch((err)=>{
            
        })
    }
    const RenderData=()=>{
           if(status_code===200){
                return(
                    <Formulaire title="Formulaire de Mise à jour" type="update" date_engagement={date_engagement} setDate_engagement={setDate_engagement} telephone={telephone} setTelephone={setTelephone} email={email} setEmail={setEmail} HandleSubmit_status={HandleSubmit_status} handleEmailChange={handleEmailChange} errors={errors} setErrors={setErrors} reinitialiser={reinitialiser}  my_domaine={my_domaine} setMy_domaine={setMy_domaine} setNom={setNom} setPostnom={setPostnom} setPrenom={setPrenom} setSexe={setSexe} setDate_naissance={setDate_naissance} setLieu_naissance={setLieu_naissance} nom={nom} postnom={postnom} prenom={prenom} sexe={sexe} date_naissance={date_naissance} lieu_naissance={lieu_naissance} HandleSubmit={HandleSubmit} setNiveau={setNiveau} niveau={niveau} adresse={adresse} setAdresse={setAdresse} setNom_complet={setNom_complet} >
                    <div className="col-md-6  mb-2">
                        <div className="form-outline">
                            <label className="form-labl" for="grid-first-name">
                                NOM COMPLET : <span class="obligatoire">*</span>
                            </label>
                            <input className="form-control form-control-lg" id="grid-first-name" type="text" placeholder="Akonkwa Ganywamulume Jean-Claude" name="nom_complet" value={nom_complet} />
                        </div>
                    </div>
                </Formulaire>
                )
                
         }
    }
   return(
        <>
          
            <div>
                {RenderData()}
            </div>
           <Sweetalert2 {...swalProps}>
                    <h3 className='text-primary'>
                        {status_message}
                    </h3>
           </Sweetalert2>
          
        </>
    )
}
export default Update